import * as NumberUtils from '@/utils/NumberUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import $store from '@/store'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import lodash from 'lodash'
import DateUtils from '@/utils/dateUtils'
import { sortByMultiField } from '@/utils'
import { Assert } from '@/utils/validate'
import { getUuid } from '@/utils'
import lang from '@/lang'
import { Company } from '@/class/model/mdm/Company'
import StrUtils from '@/utils/StrUtils'
import { Billing } from '@/class/model/act/Billing'
import * as BillingRateUtil from '@/class/cargo/model/utils/BillingRateUtil'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import {
  CHARGE_SOURCE_DIFFERENCE_PROCESSING,
  CHARGE_SOURCE_SPLIT
} from '@/class/cargo/model/parameters/SystemConstants'
/**
 * 计算分币种合计
 */
export function groupCurrencyAmount(billing, charges) {
  const map = new Map()
  for (let i = 0; i < charges.length > 0; i++) {
    const charge = charges[i]
    const chargeCurrency = charge.chargeCurrency
    const chargeReceivable = charge.chargeReceivable
    const chargeAmount = isNaN(charge.chargeAmount) ? 0.00 : charge.chargeAmount
    if (!map.has(chargeCurrency)) {
      map.set(chargeCurrency, 0.00)
    }
    const flag = chargeReceivable === billing.ar ? 1 : -1
    let total = map.get(chargeCurrency)
    total += chargeAmount * flag
    map.set(chargeCurrency, total)
  }
  let total = ''
  map.forEach(function(value, key) {
    total += key + ':' + NumberUtils.ToFixed2(value, 2) + ';'
  })
  billing.currencyAmount = total
}

/**
 * 汇总账单金额以及税额
 */
export async function sumBillingAmount(billing, charges) {
  let excludingTaxAmountTotal = 0.00// 税金
  let billingAmount = 0.00 // 账单金额
  await cache.load(cacheName.CONFIG)
  const isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
  for (let i = 0; i < charges.length > 0; i++) {
    const charge = charges[i]
    const chargeCurrency = charge.chargeCurrency
    const chargeReceivable = charge.chargeReceivable
    const chargeExcludingTaxAmount = charge.chargeExcludingTaxAmount
    const chargeAmount = chargeReceivable ? charge.chargeAmount : -charge.chargeAmount
    const chargeTaxAmount = chargeReceivable ? chargeExcludingTaxAmount : -chargeExcludingTaxAmount
    if (chargeCurrency === billing.currency) {
      billingAmount += isNaN(chargeAmount) ? 0 : chargeAmount
      excludingTaxAmountTotal += isNaN(chargeTaxAmount) ? 0 : chargeTaxAmount
    } else {
      // 根据费用币种和账单币种以及账单日期去查询汇率
      let rate = 0
      if (isSaveBillRate) {
        rate = await BillingRateUtil.getForeignExchangeRateSafely(billing.currency, chargeCurrency, billing.inputDate, 0, false)
      } else {
        rate = await RateUtil.getForeignExchangeRateSafely(billing.currency, chargeCurrency, billing.inputDate, billing.branchId, 0, false)
      }
      billingAmount += NumberUtils.ToFixed2((isNaN(chargeAmount) ? 0 : chargeAmount) * rate, 2)
      excludingTaxAmountTotal += NumberUtils.ToFixed2((isNaN(chargeTaxAmount) ? 0 : chargeTaxAmount) * rate, 2)
    }
  }
  billing.amount = billing.ar ? NumberUtils.ToFixed2(billingAmount, 2) : NumberUtils.ToFixed2(-billingAmount, 2)
  billing.taxAmount = billing.ar ? NumberUtils.ToFixed2(billingAmount - excludingTaxAmountTotal, 2) : NumberUtils.ToFixed2(excludingTaxAmountTotal - billingAmount, 2)
  billing.taxFreeAmount = billing.amount - billing.taxAmount
}

/**
 * 按费用创建账单
 */
export async function createBillingByCharge(dataSource, sourceCharges, makeBillingPaymentReceiveMethod, createBillWay) {
  const charges = dataSource === 0 ? sourceCharges : getConfirmCharges(sourceCharges)
  if (charges && charges.length > 0) {
    const billing = await createBilling(charges, makeBillingPaymentReceiveMethod, createBillWay)
    return billing
  }
  return null
}

/**
 * 按业务创建账单
 * dataSource 0.选择的费用  1.确认过的费用
 */
export async function createBillingByJob(dataSource, sourceJobs, makeBillingPaymentReceiveMethod, createBillWay) {
  const jobs = dataSource === 0 ? sourceJobs : getConfirmJobs(sourceJobs)
  let charges = []
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    const list = job['charges']
    if (list && list.length > 0) {
      charges = charges.concat(list)
    }
  }
  const billing = await createBilling(charges, makeBillingPaymentReceiveMethod, createBillWay)
  return billing
}

export function getConfirmCharges(charges) {
  const result = charges.filter(charge => {
    return charge['chargeConfirmState'] === 1 && !charge['billingUuid']
  })
  return result
}

/**
 * 获取确认的job
 */
export function getConfirmJobs(sourceJobs) {
  const result = sourceJobs.filter(charge => {
    return charge['chargeConfirmState'] === 1
  })
  return result
}

/**
 * 是否可以创建账单
 */
export function createBillingable(charges, createBillWay) {
  if (charges === null || charges.length === 0) {
    Assert.isTrue(false, lang.t('CargoMsg.Cargo_NoExpenseToBill'), 'warning').then(r => {})
    // Message.warning('没有费用可做账单！')
    return false
  }
  let oversea = false
  let first = true
  let count = 0
  let sameAccount = true
  let accountId = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (first) {
      first = false
      oversea = charge['chargeOversea']
    } else if (charge['chargeOversea'] !== oversea) {
      Assert.isTrue(false, lang.t('CargoMsg.Cargo_BOECTBCIWBII'), 'warning').then(r => {})
      return false
    }

    // if (!charge['billingUuid'] && Number(charge['chargeVerifiedAmount']) === 0) {
    //   count++
    // }

    if (!charge['billingUuid']) {
      count++
    }

    if (accountId === 0) {
      accountId = charge['chargeAccountId']
    } else if (accountId !== charge['chargeAccountId']) {
      sameAccount = false
      break
    }
  }

  // 按 结算代理 创建账单无需校验结算对象一致
  if (!sameAccount && !createBillWay) {
    Assert.isTrue(false, lang.t('CargoMsg.Cargo_SettlingPartyMustBeIdentical'), 'warning').then(r => {})
    return false
  }

  if (count === 0) {
    Assert.isTrue(false, lang.t('CargoMsg.Cargo_NoExpenseToBill'), 'warning').then(r => {})
    return false
  }
  return true
}

/**
 * 创建账单
 */
export async function createBilling(charges, makeBillingPaymentReceiveMethod, createBillWay) {
  if (!createBillingable(charges, createBillWay)) return null

  const list = []
  let flag = false
  let oversea = false
  let accountId = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (accountId === 0) {
      accountId = charge['chargeAccountId']
    }
    oversea = charge['chargeOversea']
    if (!charge['billingUuid']) {
      list.push(charge)
    } else {
      flag = true
    }
  }
  const firstCharge = list[0]
  const billing = new Billing().fillDefaultValue().getData()
  billing.makeBillingPaymentReceiveMethod = makeBillingPaymentReceiveMethod
  billing.branchId = $store.getters.currentOfficeId
  billing.ar = isReceivable(list, makeBillingPaymentReceiveMethod)
  billing.billingType = oversea ? BillingConstants.BILLING_TYPE_OVERSEA.code : BillingConstants.BILLING_TYPE_INTERNAL.code
  billing.accountId = accountId
  billing.inputBy = $store.getters.userId
  billing.inputDate = DateUtils.formatStandardDate(new Date(), 'YYYY-MM-DD')
  billing.currency = firstCharge['chargeCurrency']
  billing.makeInvoiceType = 0
  billing.invoiceRemark = ''
  billing.invoiceUsdRemark = ''
  billing.remarkAddContent = ''
  billing.detailMakeInvoice = true
  billing.splitMakeInvoice = true
  billing.billingBeforehandVOS = []
  await cache.load(cacheName.CONFIG)
  const isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
  const localCurrency = RateUtil.localCurrencyByOffice()
  if (isSaveBillRate) {
    billing.rate = await BillingRateUtil.getForeignExchangeRateSafely(localCurrency, billing.currency, billing.inputDate)
  } else {
    billing.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, billing.currency, billing.inputDate, billing.branchId)
  }

  await sumBillingAmount(billing, list)
  const accountCompany = await Company.getCompanyById(accountId)
  if (accountCompany) {
    billing.accountAddr = accountCompany.accountAddr
  }
  billing.currencyAmount = groupCurrencyAmount(billing, list)
  return { 'billing': billing, 'includePaidoff': flag, 'charges': list }
}

/**
 * 是否是应收
 */
export function isReceivable(charges, makeBillingPaymentReceiveMethod) {
  let totalAr = 0
  let totalAp = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeReceivable']) {
      totalAr += charge['chargeAmount'] * charge['chargeExchangeRate']
    } else {
      totalAp += charge['chargeAmount'] * charge['chargeExchangeRate']
    }
  }
  if (totalAr === totalAp) {
    if (makeBillingPaymentReceiveMethod === 1) {
      return true
    } else if (makeBillingPaymentReceiveMethod === 0) {
      return false
    } else { // 其他情况默认取费用的第一条的收付类型
      return charges && charges.length > 0 ? charges[0].chargeReceivable : true
    }
  }
  return totalAr > totalAp
}

/**
 * 创建账单
 */
export async function createBillingNoCharge(isAr) {
  const billing = new Billing().fillDefaultValue().getData()
  billing.branchId = $store.getters.currentOfficeId
  billing.ar = isAr
  billing.billingType = BillingConstants.BILLING_TYPE_INTERNAL.code
  billing.accountId = 0
  billing.inputBy = $store.getters.userId
  billing.inputDate = DateUtils.formatStandardDate(new Date(), 'YYYY-MM-DD')
  billing.currency = 'RMB'
  billing.affirm = false
  billing.makeInvoiceType = 0
  billing.invoiceRemark = ''
  billing.invoiceUsdRemark = ''
  billing.remarkAddContent = ''
  billing.detailMakeInvoice = true
  billing.splitMakeInvoice = true
  billing.billingBeforehandVOS = []
  await cache.load(cacheName.CONFIG)
  const isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
  const localCurrency = RateUtil.localCurrencyByOffice()
  if (isSaveBillRate) {
    billing.rate = await BillingRateUtil.getForeignExchangeRateSafely(localCurrency, billing.currency, billing.inputDate)
  } else {
    billing.rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, billing.currency, billing.inputDate, billing.branchId)
  }
  billing.amount = 0
  billing.taxAmount = 0
  billing.taxFreeAmount = 0
  billing.currencyAmount = 0
  return billing
}

/**
 * 批量取消确认业务
 */
export function cancelConfirmJobs(jobs) {
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    const charges = job['charges']
    if (charges && charges.length > 0) {
      job['dirty'] = true
      const count = cancelConfirmCharges(charges)
      job['chargeDiffAmount'] = Number(job['chargeAmount']) - Number(job['chargeBillingAmount'])
      job['chargeBillingAmount'] = 0
      if (charges.length === count) {
        job['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_UNCONFIRM.code
      }
    }
  }
  return jobs
}

/**
 * 批量取消确认费用
 */
export function cancelConfirmCharges(charges) {
  let count = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeConfirmState'] === ChargeConstants.CONFIRM_STATE_CONFIRMED.code && (charge['chargeDifferentState'] === 0 || charge['chargeDifferentState'] === 3)) {
      count++
      charge['chargeBillingAmount'] = 0
      charge['chargeDiffAmount'] = Number(charge['chargeAmount'])
      charge['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_UNCONFIRM.code
      charge['chargeConfirmDate'] = null
      charge['chargeConfirmUser'] = 0
      charge['dirty'] = true
    }
  }
  return count
}

/**
 * 批量取消确认费用
 */
export function cancelConfirmCharges2(charges) {
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeConfirmState'] === ChargeConstants.CONFIRM_STATE_CONFIRMED.code && (charge['chargeDifferentState'] === 0 || charge['chargeDifferentState'] === 3)) {
      charge['chargeBillingAmount'] = 0
      charge['chargeDiffAmount'] = Number(charge['chargeAmount'])
      charge['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_UNCONFIRM.code
      charge['chargeConfirmDate'] = null
      charge['chargeConfirmUser'] = 0
      charge['dirty'] = true
    }
  }
  return charges
}

/**
 * 批量确认业务
 */
export function confirmJobs(jobs) {
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    if (job['chargeConfirmState'] === 0) {
      job['dirty'] = true
      job['chargeBillingAmount'] = job['chargeAmount']
      const charges = job['charges']
      if (charges && charges.length > 0) {
        const count = confirmCharges(charges)
        job['chargeDiffAmount'] = Number(job['chargeAmount']) - Number(job['chargeBillingAmount'])
        if (charges.length === count) {
          job['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_CONFIRMED.code
        }
      }
    }
  }
  return jobs
}

/**
 * 批量确认费用
 */
export function confirmCharges(charges) {
  let count = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeConfirmState'] === 0 && charge['chargeVerifiedAmount'] === 0) {
      count++
      charge['dirty'] = true
      charge['chargeBillingAmount'] = charge['chargeAmount']
      charge['chargeDiffAmount'] = 0
      charge['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_CONFIRMED.code
      charge['chargeConfirmDate'] = DateUtils.formatStandardDate(new Date())
      charge['chargeConfirmUser'] = $store.getters.userId
    }
  }
  return count
}

/**
 * 批量确认费用
 */
export function confirmCharges2(charges) {
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeConfirmState'] === 0 && charge['chargeVerifiedAmount'] === 0) {
      charge['dirty'] = true
      charge['chargeBillingAmount'] = charge['chargeAmount']
      charge['chargeDiffAmount'] = 0
      charge['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_CONFIRMED.code
      charge['chargeConfirmDate'] = DateUtils.formatStandardDate(new Date())
      charge['chargeConfirmUser'] = $store.getters.userId
    }
  }
  return charges
}

/**
 * 处理业务上的费用差额
 */
export function processJobDiffAmount(jobs, isCall = false) {
  let diffCharges = []
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    const charges = job['charges']
    if (job['chargeBillingAmount'] !== 0 && charges && charges.length > 0) {
      const list = processChargeDiffAmount(charges, isCall)
      if (list.length > 0) {
        diffCharges = diffCharges.concat(list)
        job['chargeConfirmState'] = 1
      }
    }
  }
  return diffCharges
}

/**
 * 处理费用差额
 */
export async function processChargeDiffAmount(charges, callBack) {
  const diffCharges = []
  const userId = $store.getters.userId
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    const verifiedAmount = Number(charge['chargeVerifiedAmount'])
    const billingAmount = Number(charge['chargeBillingAmount'])
    const amount = Number(charge['chargeAmount'])
    const confirmState = charge['chargeConfirmState']
    const differentState = charge['chargeDifferentState']
    await cache.load(cacheName.CONFIG)
    const diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
    const chargeAmount = Math.abs(charge['chargeAmount'])// 取绝对值后的费用金额
    const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额

    if (!charge['uuid']) {
      callBack()
      return diffCharges
    }
    if (verifiedAmount === 0 && billingAmount !== 0) {
      if (amount === billingAmount && confirmState === 0) {
        charge['chargeConfirmState'] = 1
        charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        charge['chargeConfirmUser'] = userId
      } else if (amount !== billingAmount && (differentState === 0 || differentState === 3)) {
        let value = 0
        if (diffChargeByBillingAmountPattern === 1) {
          if ((chargeAmount < billingAmountNew) || (amount > 0 && billingAmount < 0) || (amount < 0 && billingAmount > 0)) {
            Assert.isTrue(false, lang.t('CargoMsg.Cargo_TRAYEINR'), 'warning').then(r => {})
            return diffCharges
          } else {
            if (amount > billingAmount && amount > 0) {
              value = amount - billingAmount
            } else if (chargeAmount > billingAmountNew && amount < 0) {
              value = -(chargeAmount - billingAmountNew)
            } else if (amount === billingAmount) {
              value = -amount
            } else {
              charge['chargeConfirmState'] = 1
              charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
              charge['chargeConfirmUser'] = userId
              continue
            }
          }
        } else {
          if (amount > billingAmount) { value = amount - billingAmount } else if (amount === billingAmount) { value = -amount } else {
            value = billingAmount - amount
          }
        }
        value = NumberUtils.roundHalfUp(value, 2)
        charge['chargeConfirmState'] = 1
        charge['chargeDifferentState'] = 1
        charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        charge['chargeConfirmUser'] = userId
        let positiveCharge = {}
        let minusCharge = {}
        if ((chargeAmount > billingAmountNew && amount > 0) || diffChargeByBillingAmountPattern === 0) {
          positiveCharge = generateDiffCharge(value, charge)
          minusCharge = generateDiffCharge(-value, charge)
        } else {
          positiveCharge = generateDiffCharge(-value, charge)
          minusCharge = generateDiffCharge(value, charge)
        }
        positiveCharge['relatedId'] = charge['chargeChargeId']
        positiveCharge['chargeSource'] = CHARGE_SOURCE_DIFFERENCE_PROCESSING.code
        minusCharge['relatedId'] = charge['chargeChargeId']
        minusCharge['chargeSource'] = CHARGE_SOURCE_DIFFERENCE_PROCESSING.code
        if (amount >= billingAmount) {
          positiveCharge['chargeConfirmRemarks'] = ''
          positiveCharge['chargeDifferentState'] = 3
          positiveCharge['chargeConfirmUser'] = 0
          positiveCharge['chargeConfirmDate'] = null
          minusCharge['chargeDifferentState'] = 2
          minusCharge['chargeConfirmState'] = 1
          minusCharge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
          minusCharge['chargeConfirmUser'] = userId
        } else {
          minusCharge['chargeConfirmRemarks'] = ''
          minusCharge['chargeDifferentState'] = 3
          minusCharge['chargeConfirmUser'] = 0
          minusCharge['chargeConfirmDate'] = null
          positiveCharge['chargeDifferentState'] = 2
          positiveCharge['chargeConfirmState'] = 1
          positiveCharge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
          positiveCharge['chargeConfirmUser'] = userId
        }

        if (positiveCharge['chargeAmount'] !== 0) {
          positiveCharge['chargeType'] = 'positiveCharge'
          diffCharges.push(positiveCharge)
        }
        if (minusCharge['chargeAmount'] < 0) {
          minusCharge['chargeType'] = 'minusCharge'
          diffCharges.push(minusCharge)
        }
      }
    }
  }
  return diffCharges
}

/**
 * 生成正数费用
 */
export function generateDiffCharge(amount, origin) {
  const charge = createDiffCharge(origin)
  charge['chargeAmount'] = NumberUtils.roundHalfUp(amount)
  charge['chargeExcludingTaxAmount'] = NumberUtils.roundHalfUp(amount * 100) / (100 + Number(charge['chargeTaxRate']))
  charge['chargeTaxAmount'] = NumberUtils.roundHalfUp(amount - Number(charge['chargeExcludingTaxAmount']))
  charge['chargeDiffAmount'] = NumberUtils.roundHalfUp(amount)
  charge['chargeUnitRate'] = NumberUtils.roundHalfUp(amount)
  charge['chargeUnverifiedAmount'] = NumberUtils.roundHalfUp(amount - Number(charge['chargeVerifiedAmount']))

  return charge
}

/**
 * 生成差额费用
 */
export function createDiffCharge(origin) {
  const charge = {}
  for (const key in origin) {
    if (key.indexOf('job') === 0) {
      charge[key] = origin[key]
    }
  }
  charge['uuid'] = null
  charge['chargeUid'] = getUuid() // 新增未保存费用的唯一标识
  charge['job'] = origin['job']
  charge['chargeDiffChargeUuid'] = origin['uuid']
  charge['chargeAccountId'] = origin['chargeAccountId']
  charge['chargeBranchId'] = origin['chargeBranchId']
  charge['chargeOversea'] = origin['chargeOversea']
  charge['chargeChargeItemId'] = origin['chargeChargeItemId']
  charge['chargeReceivable'] = origin['chargeReceivable']
  charge['chargeCurrency'] = origin['chargeCurrency']
  charge['chargeMeasure'] = origin['chargeMeasure']
  charge['chargeExchangeRate'] = origin['chargeExchangeRate']
  charge['chargeAmount'] = origin['chargeAmount']
  charge['chargeExcludingTaxAmount'] = origin['chargeExcludingTaxAmount']
  charge['chargeTaxRate'] = origin['chargeTaxRate']
  charge['chargeConfirmRemarks'] = origin['chargeConfirmRemarks']
  charge['chargeChargeState'] = origin['chargeChargeState']
  charge['chargeAccountingDate'] = origin['chargeAccountingDate']
  charge['chargeContactPerson'] = origin['chargeContactPerson']
  charge['chargeBusinessDate'] = origin['chargeBusinessDate']
  charge['chargeQuantity'] = 1
  charge['chargeUnitRate'] = 1
  charge['chargeInputBy'] = $store.getters.userId
  charge['chargeInputDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
  charge['chargeAuditor'] = $store.getters.userId
  charge['chargeTaxAmount'] = 0
  charge['chargeVerifiedAmount'] = 0
  charge['chargeBillingAmount'] = 0
  charge['chargeConfirmState'] = 0
  return charge
}

/**
 * 从费用列表中获取需要保存的费用
 */
export function getNeedSaveChanges(charges) {
  const saveCharges = []
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    const billingAmount = isNaN(charge['chargeBillingAmount']) ? 0.0 : charge['chargeBillingAmount']
    if (charge['uuid'] && charge['dirty'] === true) {
      const update = {}
      update['uuid'] = charge['uuid']
      update['version'] = charge['version']
      update['confirmState'] = Number(charge['chargeConfirmState'])
      update['confirmDate'] = charge['chargeConfirmDate']
      update['confirmUser'] = charge['chargeConfirmUser']
      update['amount'] = Number(charge['chargeAmount'])
      update['excludingTaxAmount'] = Number(charge['chargeExcludingTaxAmount'])
      update['taxAmount'] = Number(charge['chargeTaxAmount'])
      update['billingAmount'] = billingAmount
      update['invoiceAmount'] = Number(charge['chargeInvoiceAmount'])
      update['invoiceExcludingTax'] = Number(charge['chargeInvoiceExcludingTax'])
      update['invoiceTax'] = Number(charge['chargeInvoiceTax'])
      update['confirmRemarks'] = charge['chargeConfirmRemarks']
      update['invoiceUuid'] = charge['invoiceUuid']
      update['currency'] = charge['chargeCurrency']
      update['chargeUid'] = charge['chargeUid']
      update['chargeConfirmSerialNumber'] = charge['chargeConfirmSerialNumber'] ? charge['chargeConfirmSerialNumber'] + '' : ''
      saveCharges.push(update)
    } else if (!charge['uuid']) {
      const amount = isNaN(charge['chargeAmount']) ? 0 : parseFloat(charge['chargeAmount'])
      const excludingTaxAmount = isNaN(charge['chargeExcludingTaxAmount']) ? 0 : parseFloat(charge['chargeExcludingTaxAmount'])
      const taxAmount = isNaN(charge['chargeTaxAmount']) ? 0 : parseFloat(charge['chargeTaxAmount'])
      const unitRate = isNaN(charge['chargeUnitRate']) ? 0 : parseFloat(charge['chargeUnitRate'])
      const invoiceAmount = isNaN(charge['chargeInvoiceAmount']) ? 0 : parseFloat(charge['chargeInvoiceAmount'])
      const invoiceExcludingTax = isNaN(charge['chargeInvoiceExcludingTax']) ? 0 : parseFloat(charge['chargeInvoiceExcludingTax'])
      const invoiceTax = isNaN(charge['chargeInvoiceTax']) ? 0 : parseFloat(charge['chargeInvoiceTax'])
      const diff = {}
      diff['diffChargeUuid'] = charge['chargeDiffChargeUuid']
      diff['invoiceUuid'] = charge['invoiceUuid']
      diff['confirmState'] = parseInt(charge['chargeConfirmState'])
      diff['billingAmount'] = NumberUtils.roundHalfUp(billingAmount)
      diff['amount'] = NumberUtils.roundHalfUp(amount)
      diff['excludingTaxAmount'] = NumberUtils.roundHalfUp(excludingTaxAmount)
      diff['taxAmount'] = NumberUtils.roundHalfUp(taxAmount)
      diff['unitRate'] = NumberUtils.roundHalfUp(unitRate)
      diff['invoiceAmount'] = NumberUtils.roundHalfUp(invoiceAmount)
      diff['invoiceExcludingTax'] = NumberUtils.roundHalfUp(invoiceExcludingTax)
      diff['invoiceTax'] = NumberUtils.roundHalfUp(invoiceTax)
      diff['confirmRemarks'] = charge['chargeConfirmRemarks']
      diff['remarks'] = charge['chargeRemarks']
      diff['currency'] = charge['chargeCurrency']
      diff['chargeUid'] = charge['chargeUid']
      // 保存对账时，把关联传到后台
      diff['relatedId'] = charge['relatedId']
      diff['chargeSource'] = charge['chargeSource']
      diff['chargeConfirmSerialNumber'] = charge['chargeConfirmSerialNumber'] ? charge['chargeConfirmSerialNumber'] + '' : ''
      saveCharges.push(diff)
    }
  }
  return saveCharges
}

/**
 * 过滤出需要更新的费用
 */
export function filterNeedUpdateCharges(charges) {
  const updates = []
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['uuid']) {
      updates.push({ 'uuid': charge['uuid'], 'version': charge['version'] })
    }
  }
  return updates
}

/**
 * 确认是否编辑
 */
export function checkEditable(data) {
  let bool = true
  let confirmState = 0
  let verifiedAmount = 0
  if (data['entity'] === 'charge') {
    confirmState = parseInt(data['chargeConfirmState'])
    verifiedAmount = parseInt(data['chargeVerifiedAmount'])
    const differentState = parseFloat(data['chargeDifferentState'])
    bool = (confirmState === 0 && verifiedAmount === 0 && (differentState === 0 || differentState === 3))
  } else if (data['entity'] === 'job') {
    let chargeEditable = true
    for (const charge of data['charges']) {
      if (charge['chargeConfirmState'] === 1 && (charge['chargeDifferentState'] === 1 || charge['chargeDifferentState'] === 2 || charge['chargeVerifiedAmount'] !== 0)) {
        chargeEditable = false
        break
      }
    }
    if (!(data['chargeConfirmState'] === 0 && chargeEditable)) {
      bool = false
    }
  }
  return bool
}

/**
 * 是否可以确认
 */
export function checkConfirmable(data) {
  let bool = true
  if (data['entity'] === 'charge') {
    const differentState = parseFloat(data['chargeDifferentState'])
    bool = differentState === 0 || differentState === 3
  } else if (data['entity'] === 'job') {
    for (const charge of data['charges']) {
      if (charge['chargeConfirmState'] === 1 && (charge['chargeDifferentState'] === 1 || charge['chargeDifferentState'] === 2 || charge['chargeVerifiedAmount'] !== 0)) {
        bool = false
        break
      }
    }
  }
  return bool
}

/**
 * 将拆分过的费用合并成JOB
 */
export function splitChargeMergeToJob(charges) {
  const map = {}
  const jobs = []
  for (const charge of charges) {
    const jobKey = charge['job']['uuid']
    const confirmState = charge['chargeConfirmState']
    const accountId = charge['job']['chargeAccountId']
    const isAr = charge['job']['chargeReceivable']
    const currency = charge['job']['chargeCurrency']

    const key = jobKey + '-' + currency + '-' + isAr + '-' + accountId + '-' + confirmState
    let job = {}
    if (map[key]) {
      job = map[key]
      job['chargeBillingAmount'] += charge['chargeBillingAmount']
      job['chargeAmount'] = sum(job['charges'])
    } else {
      job = lodash.cloneDeep(charge['job'])
      job['dirty'] = true
      job['charges'] = []
      job['chargeBillingAmount'] = charge['chargeBillingAmount']
      job['chargeAmount'] = charge['chargeAmount']
      job['chargeConfirmState'] = charge['chargeConfirmState']
      map[key] = job
      jobs.push(job)
    }
    job['chargeDiffAmount'] = NumberUtils.roundHalfUp(job['chargeAmount'] - job['chargeBillingAmount'])
    let charges = []
    if (job.hasOwnProperty('charges')) {
      charges = job['charges']
      if (!charges) {
        charges = []
      }
    }
    charges.push(charge)
    job['charges'] = charges
  }
  return jobs
}

/**
 * 汇总
 */
export function sum(items, dataField = 'amount') {
  let total = 0
  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    total += item[dataField]
  }
  return total
}

/**
 * 拆分费用
 */
export async function splitCharges(charges, callBack) {
  await cache.load(cacheName.CONFIG)
  const userId = $store.getters.userId
  const diffCharges = []
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (!charge['billPaymentUuid'] && charge['chargeVerifiedAmount'] === 0 && charge['chargeBillingAmount'] !== 0) {
      if (!charge['uuid']) {
        callBack(1)
        return diffCharges
      }
      const diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
      const amount = charge['chargeAmount']
      const billingAmount = charge['chargeBillingAmount']
      const chargeAmountNew = Math.abs(amount)// 取绝对值后的费用金额
      const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额
      let chargeAmount = 0.00
      if (diffChargeByBillingAmountPattern === 1) {
        let count = 0
        if ((chargeAmountNew < billingAmountNew) || (amount > 0 && billingAmount < 0) || (amount < 0 && billingAmount > 0)) {
          count++
          if (count === 1) {
            callBack(2)
            return diffCharges
          }
        } else {
          if (amount > billingAmount && amount > 0) { chargeAmount = amount - billingAmount } else if (chargeAmountNew > billingAmountNew && amount < 0) { chargeAmount = -(chargeAmountNew - billingAmountNew) } else {
            charge['dirty'] = true
            charge['chargeConfirmState'] = 1
            charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
            charge['chargeConfirmUser'] = userId
            continue
          }
        }
      } else {
        chargeAmount = NumberUtils.roundHalfUp(amount - billingAmount)
        if (chargeAmount === 0) { continue }
      }

      const newCharge = lodash.cloneDeep(charge)
      newCharge['uuid'] = null
      newCharge['chargeUid'] = getUuid() // 新增未保存费用的唯一标识
      newCharge['job'] = charge['job']
      newCharge['chargeDiffChargeUuid'] = charge['uuid']
      newCharge['chargeAmount'] = chargeAmount
      newCharge['chargeDiffAmount'] = newCharge['chargeAmount']
      newCharge['chargeExcludingTaxAmount'] = NumberUtils.roundHalfUp((newCharge['chargeAmount'] * 100) / (100 + newCharge['chargeTaxRate']))
      newCharge['chargeTaxAmount'] = NumberUtils.ToFixed2(newCharge['chargeAmount'] - newCharge['chargeExcludingTaxAmount'], 2)
      newCharge['chargeUnverifiedAmount'] = NumberUtils.ToFixed2(newCharge['chargeAmount'] - newCharge['chargeVerifiedAmount'], 2)
      newCharge['chargeBillingAmount'] = 0
      newCharge['chargeOffsetState'] = 0
      newCharge['chargeRemarks'] = charge['chargeRemarks'] ? charge['chargeRemarks'] + ' ' : ''
      newCharge['invoiceUuid'] = charge['invoiceUuid']
      newCharge['relatedId'] = charge['chargeChargeId']
      newCharge['chargeSource'] = CHARGE_SOURCE_SPLIT.code
      newCharge['chargeRemarks'] += '拆分费用'

      // 拆分比例
      const splitPercent = charge['chargeBillingAmount'] / charge['chargeAmount']
      const billingAmountSmall = chargeAmountNew > billingAmountNew
      if (diffChargeByBillingAmountPattern === 1) { // 0.按对账金额拆分 1.对账金额不允许大于费用金额
        if (billingAmountSmall) {
          charge['chargeAmount'] = NumberUtils.roundHalfUp(charge['chargeBillingAmount'])
        }
      } else {
        charge['chargeAmount'] = NumberUtils.roundHalfUp(charge['chargeBillingAmount'])
      }
      charge['dirty'] = true
      charge['isSelect'] = false
      // charge['chargeExcludingTaxAmount'] = charge['chargeAmount'] - charge['chargeTaxAmount']
      // CARGO-39288 对账新版-调整差额生成拆分费用,原费用的不含税价以及税额计算错误
      charge['chargeExcludingTaxAmount'] = NumberUtils.ToFixed2(charge['chargeAmount'] / (1 + (charge['chargeTaxRate'] / 100)), 2)
      charge['chargeTaxAmount'] = NumberUtils.ToFixed2(charge['chargeAmount'] - charge['chargeExcludingTaxAmount'], 2)
      charge['chargeUnverifiedAmount'] = charge['chargeAmount'] - charge['chargeVerifiedAmount']
      charge['chargeDiffAmount'] = 0
      charge['chargeConfirmState'] = 1
      charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      charge['chargeConfirmUser'] = userId
      if (charge['chargeInvoiceAmount'] !== 0) {
        const chargeInvoiceAmount = charge['chargeInvoiceAmount']
        const chargeInvoiceExcludingTax = charge['chargeInvoiceExcludingTax']
        const chargeInvoiceTax = charge['chargeInvoiceTax']
        charge['chargeInvoiceAmount'] = NumberUtils.ToFixed2(charge['chargeInvoiceAmount'] * splitPercent, 2)
        charge['chargeInvoiceExcludingTax'] = NumberUtils.ToFixed2(charge['chargeInvoiceExcludingTax'] * splitPercent, 2)
        charge['chargeInvoiceTax'] = NumberUtils.ToFixed2(charge['chargeInvoiceTax'] * splitPercent, 2)
        // 拆分费用
        newCharge['chargeInvoiceAmount'] = NumberUtils.ToFixed2(chargeInvoiceAmount - charge['chargeInvoiceAmount'], 2)
        newCharge['chargeInvoiceExcludingTax'] = NumberUtils.ToFixed2(chargeInvoiceExcludingTax - charge['chargeInvoiceExcludingTax'], 2)
        newCharge['chargeInvoiceTax'] = NumberUtils.ToFixed2(chargeInvoiceTax - charge['chargeInvoiceTax'], 2)
      }
      diffCharges.push(newCharge)
    }
  }
  return diffCharges
}

/**
 * 按业务拆分费用
 */
export async function splitJobCharges(jobs, alertCall) {
  let diffCharges = []
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    if (job['charges']) {
      const result = await splitCharges(job['charges'], alertCall)
      if (result && result.length > 0) {
        diffCharges = diffCharges.concat(result)
        job['isSelect'] = false
        job['chargeAmount'] = job['chargeBillingAmount']
        job['chargeConfirmState'] = 1
      }
    }
  }
  return diffCharges
}
/**
 * 分摊对账金额
 */
export function shareJobBillingAmount(job) {
  let charges = job['charges']
  if (!charges) { return }

  let charge = null
  if (charges.length === 1) {
    charge = charges[0]
    charge['chargeBillingAmount'] = Number(job['chargeBillingAmount'])
  } else {
    charges = sortByMultiField(charges, ['chargeAmount'], false)
    let billingAmount = Number(job['chargeBillingAmount'])
    const len = charges.length
    let isBreak = false
    for (let i = 0; i < len; i++) {
      charge = charges[i]
      if (i === len - 1 || billingAmount <= charge['chargeAmount']) {
        charge['chargeBillingAmount'] = billingAmount
        billingAmount = 0
        isBreak = true
      }
      if (!isBreak) {
        charge['chargeBillingAmount'] = (billingAmount - charge['chargeAmount']) > 0 ? charge['chargeAmount'] : charge['chargeAmount'] - billingAmount
        billingAmount -= Number(charge['chargeAmount'])
      }
    }
  }
}

/**
 * 汇总费用的总差额
 */
export async function sumChargeDiffAmount(job) {
  const charges = job['charges']
  if (!charges) { return 0 }

  let total = 0.00
  let totalChargeAmount = 0.00
  let billingAmount = 0.00// 输入的对账金额
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    total = total + charge['chargeAmount'] - charge['chargeBillingAmount']
    totalChargeAmount += charge['chargeAmount']
    billingAmount += charge['chargeBillingAmount']
  }

  await cache.load(cacheName.CONFIG)
  const diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
  const chargeAmount = Math.abs(totalChargeAmount)// 取绝对值后的费用总金额
  const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额
  if (diffChargeByBillingAmountPattern === 1) {
    if ((chargeAmount < billingAmountNew) || (totalChargeAmount > 0 && billingAmount < 0) || (totalChargeAmount < 0 && billingAmount > 0)) {
      Assert.isTrue(false, lang.t('CargoMsg.Cargo_TRAYEINR'), 'warning').then(r => {})
      job['chargeBillingAmount'] = 0.00
      return Number(job['chargeAmount'])
    } else {
      if (totalChargeAmount > 0) {
        total = totalChargeAmount - billingAmount
      } else {
        total = -(chargeAmount - billingAmountNew)
      }
    }
  }
  return NumberUtils.roundHalfUp(total, 2)
}

/**
 * 确认是否编辑
 */
export function checkEditableForReconciliation(data) {
  let bool = true
  let confirmState = 0
  let verifiedAmount = 0
  if (data['entity'] === 'charge') {
    confirmState = parseInt(data['chargeConfirmState'])
    verifiedAmount = parseInt(data['chargeVerifiedAmount'])
    const differentState = parseFloat(data['chargeDifferentState'])
    bool = (confirmState === 0 && verifiedAmount === 0 && (differentState === 0 || differentState === 3))
  } else if (data['entity'] === 'job') {
    let chargeEditable = true
    for (const charge of data['charges']) {
      if (charge['chargeConfirmState'] === 1 && charge['chargeVerifiedAmount'] !== 0) {
        chargeEditable = false
        break
      }
    }
    if (!(data['chargeConfirmState'] === 0 && chargeEditable)) {
      bool = false
    }
  }
  return bool
}

/**
 * 是否可以确认
 */
export function checkConfirmableForReconciliation(data) {
  let bool = true
  if (data['entity'] === 'charge') {
    const differentState = parseFloat(data['chargeDifferentState'])
    bool = differentState === 0 || differentState === 3
  } else if (data['entity'] === 'job') {
    for (const charge of data['charges']) {
      if (charge['chargeVerifiedAmount'] !== 0) {
        bool = false
        break
      }
    }
  }
  return bool
}

/**
 * 校验费用的开票抬头和结算代理是否一致，不一致时弹窗确认
 * @param item billing
 * @param charges 费用列表
 * @param view
 * @param useFirstChargeInvoiceTitleAndSettlement 是否使用第一条费用的开票抬头和结算代理
 * @param isJob 是否是按业务创建的账单
 * @returns {Promise<boolean>}
 */
export async function checkChargesIsSameInvoiceTitleAndSettlementAgent(item, charges, view, useFirstChargeInvoiceTitleAndSettlement, isJob) {
  if (charges && charges.length > 0) {
    const sameTitle = isJob ? isSameInvoiceTitleByJob(charges) : isSameInvoiceTitle(charges)
    const sameSettlementAgent = isJob ? isSameSettlementAgentByJob(charges) : isSameSettlementAgent(charges)
    // 开票抬头或者结算代理不一致时
    if (!sameTitle && !sameSettlementAgent) {
      if (useFirstChargeInvoiceTitleAndSettlement && charges) {
        item['billing'].title = isJob ? charges[0]['charges'][0]['chargeInvoiceTitle'] : charges[0].chargeInvoiceTitle
        item['billing'].settlementAgentId = isJob ? charges[0]['charges'][0]['chargeSettlementAgentId'] : charges[0].chargeSettlementAgentId
      }
    } else if (sameTitle && !sameSettlementAgent) {
      if (useFirstChargeInvoiceTitleAndSettlement && charges) {
        item['billing'].settlementAgentId = isJob ? charges[0]['charges'][0]['chargeSettlementAgentId'] : charges[0].chargeSettlementAgentId
      }
    } else if (!sameTitle && sameSettlementAgent) {
      if (useFirstChargeInvoiceTitleAndSettlement && charges) {
        item['billing'].title = isJob ? charges[0]['charges'][0]['chargeInvoiceTitle'] : charges[0].chargeInvoiceTitle
      }
    } else {
      if (useFirstChargeInvoiceTitleAndSettlement && charges) {
        item['billing'].title = isJob ? charges[0]['charges'][0]['chargeInvoiceTitle'] : charges[0].chargeInvoiceTitle
        item['billing'].settlementAgentId = isJob ? charges[0]['charges'][0]['chargeSettlementAgentId'] : charges[0].chargeSettlementAgentId
      }
    }
  }
}
// export async function checkChargesIsSameInvoiceTitleAndSettlementAgent(item, charges, view, useFirstChargeInvoiceTitleAndSettlement, isJob) {
//   if (!charges || charges.length === 0) {
//     return false
//   }
//   const sameTitle = isJob ? isSameInvoiceTitleByJob(charges) : isSameInvoiceTitle(charges)
//   const sameSettlementAgent = isJob ? isSameSettlementAgentByJob(charges) : isSameSettlementAgent(charges)
//   let checkTitleAndSettlementAgent = false
//   let message = ''
//   if (!sameTitle && !sameSettlementAgent) {
//     message = lang.t('Message.SettlingAgentInvoiceTitleInconsistent')
//   } else if (sameTitle && !sameSettlementAgent) {
//     message = lang.t('Message.SettlingAgentInconsistent')
//   } else if (!sameTitle && sameSettlementAgent) {
//     message = lang.t('Message.TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue')
//   }
//   // 开票抬头或者结算代理不一致时
//   if (!StrUtils.isEmpty(message)) {
//     await view.$confirm(message, lang.t('Message.Prompt'), {
//       confirmButtonText: lang.t('common.btn.ok'),
//       cancelButtonText: lang.t('common.btn.cancel'),
//       distinguishCancelAndClose: true,
//       type: 'warning'
//     }).then(() => {
//       if (!sameTitle && !sameSettlementAgent) {
//         if (useFirstChargeInvoiceTitleAndSettlement && charges) {
//           item['billing'].title = isJob ? charges[0]['charges'][0]['chargeInvoiceTitle'] : charges[0].chargeInvoiceTitle
//           item['billing'].settlementAgentId = isJob ? charges[0]['charges'][0]['chargeSettlementAgentId'] : charges[0].chargeSettlementAgentId
//         }
//       } else if (sameTitle && !sameSettlementAgent) {
//         if (useFirstChargeInvoiceTitleAndSettlement && charges) {
//           item['billing'].settlementAgentId = isJob ? charges[0]['charges'][0]['chargeSettlementAgentId'] : charges[0].chargeSettlementAgentId
//         }
//       } else if (!sameTitle && sameSettlementAgent) {
//         if (useFirstChargeInvoiceTitleAndSettlement && charges) {
//           item['billing'].title = isJob ? charges[0]['charges'][0]['chargeInvoiceTitle'] : charges[0].chargeInvoiceTitle
//         }
//       }
//     }).catch(() => {
//       checkTitleAndSettlementAgent = true
//     })
//   } else {
//     if (useFirstChargeInvoiceTitleAndSettlement && charges) {
//       item['billing'].title = isJob ? charges[0]['charges'][0]['chargeInvoiceTitle'] : charges[0].chargeInvoiceTitle
//       item['billing'].settlementAgentId = isJob ? charges[0]['charges'][0]['chargeSettlementAgentId'] : charges[0].chargeSettlementAgentId
//     }
//   }
//   return checkTitleAndSettlementAgent
// }

/**
 * 判断开票抬头是否一致， 0：不一致，1：一致
 * @param charges
 * @returns {string|*}
 */
export function isSameInvoiceTitle(charges) {
  // 只有一票费用时，直接取该票费用的开票抬头
  if (charges.length === 1) {
    return 1
  }
  let title = ''
  for (const charge of charges) {
    // 忽略开票抬头为空的数据
    if (StrUtils.isEmpty(charge.chargeInvoiceTitle)) {
      continue
    }
    if (StrUtils.isEmpty(title)) {
      title = charge.chargeInvoiceTitle
      continue
    }
    // 出现不一致的开票抬头时，直接返回不一致的结果
    if (title !== charge.chargeInvoiceTitle) {
      return 0
    }
  }
  return 1
}

/**
 * 判断开票抬头是否一致， 0：不一致，1：一致
 * @param charges
 * @returns {string|*}
 */
export function isSameInvoiceTitleByJob(jobs) {
  let title = ''
  for (const job of jobs) {
    const charges = job['charges']
    for (const charge of charges) {
      // 忽略开票抬头为空的数据
      if (StrUtils.isEmpty(charge.chargeInvoiceTitle)) {
        continue
      }
      if (StrUtils.isEmpty(title)) {
        title = charge.chargeInvoiceTitle
        continue
      }
      // 出现不一致的开票抬头时，直接返回不一致的结果
      if (title !== charge.chargeInvoiceTitle) {
        return 0
      }
    }
  }
  return 1
}

/**
 * 结算代理
 * @param charges
 * @returns {number}
 */
export function isSameSettlementAgent(charges) {
  // 只有一票费用时，直接取该票费用的开票抬头
  if (charges.length === 1) {
    return 1
  }
  let settlementAgentId = 0
  for (const charge of charges) {
    if (!charge.chargeSettlementAgentId || Number(charge.chargeSettlementAgentId) === 0) {
      continue
    }
    if (settlementAgentId === 0) {
      settlementAgentId = charge.chargeSettlementAgentId
      continue
    }
    if (settlementAgentId !== charge.chargeSettlementAgentId) {
      return 0
    }
  }
  return 1
}

/**
 * 判断结算代理是否一致， 0：不一致，1：一致
 * @param jobs
 * @returns {number}
 */
export function isSameSettlementAgentByJob(jobs) {
  let settlementAgentId = 0
  for (const job of jobs) {
    const charges = job['charges']
    for (const charge of charges) {
      if (!charge.chargeSettlementAgentId || Number(charge.chargeSettlementAgentId) === 0) {
        continue
      }
      if (settlementAgentId === 0) {
        settlementAgentId = Number(charge.chargeSettlementAgentId)
        continue
      }
      if (settlementAgentId !== Number(charge.chargeSettlementAgentId)) {
        return 0
      }
    }
  }
  return 1
}

/**
 * 结算代理
 * @param charges
 * @returns {number}
 */
export function isSameSettlementAgent2(charges) {
  // 只有一票费用时，直接取该票费用的开票抬头
  if (charges.length === 1) {
    return 1
  }
  let settlementAgentId = 0
  for (const charge of charges) {
    if (!charge.chargeSettlementAgentId && Number(charge.chargeSettlementAgentId) !== 0) {
      continue
    }
    if (settlementAgentId === 0) {
      settlementAgentId = Number(charge.chargeSettlementAgentId)
      continue
    }
    if (settlementAgentId !== Number(charge.chargeSettlementAgentId)) {
      return 0
    }
  }
  return 1
}

/**
 * 判断结算代理是否一致， 0：不一致，1：一致
 * @param jobs
 * @returns {number}
 */
export function isSameSettlementAgentByJob2(jobs) {
  let settlementAgentId = 0
  for (const job of jobs) {
    const charges = job['charges']
    for (const charge of charges) {
      if (!charge.chargeSettlementAgentId && Number(charge.chargeSettlementAgentId) !== 0) {
        continue
      }
      if (settlementAgentId === 0) {
        settlementAgentId = Number(charge.chargeSettlementAgentId)
        continue
      }
      if (settlementAgentId !== Number(charge.chargeSettlementAgentId)) {
        return 0
      }
    }
  }
  return 1
}
/**
 * 获取结算代理
 * @param charges
* @returns {number}
 */
export function getSettlementAgentIdByCharge(charges) {
  for (const charge of charges) {
    if (charge.chargeSettlementAgentId && Number(charge.chargeSettlementAgentId) !== 0) {
      return charge.chargeSettlementAgentId
    }
  }
  return 0
}

/**
 * 获取结算代理
 * @param jobs
 * @returns {number}
 */
export function getSettlementAgentIdByJob(jobs) {
  for (const job of jobs) {
    const charges = job['charges']
    return getSettlementAgentIdByCharge(charges)
  }
  return 0
}

/**
 * 结算对象
 * @param charges
 * @returns {number}
 */
export function isSameAccount(charges) {
  // 只有一票费用时，直接取该票费用的开票抬头
  if (charges.length === 1) {
    return 1
  }
  let chargeAccountId = 0
  for (const charge of charges) {
    if (!charge.chargeAccountId || Number(charge.chargeAccountId) === 0) {
      continue
    }
    if (chargeAccountId === 0) {
      chargeAccountId = Number(charge.chargeAccountId)
      continue
    }
    if (chargeAccountId !== Number(charge.chargeAccountId)) {
      return 0
    }
  }
  return 1
}

/**
 * 判断结算对象是否一致， 0：不一致，1：一致
 * @param jobs
 * @returns {number}
 */
export function isSameAccountByJob(jobs) {
  let chargeAccountId = 0
  for (const job of jobs) {
    const charges = job['charges']
    for (const charge of charges) {
      if (!charge.chargeAccountId || Number(charge.chargeAccountId) === 0) {
        continue
      }
      if (chargeAccountId === 0) {
        chargeAccountId = Number(charge.chargeAccountId)
        continue
      }
      if (chargeAccountId !== Number(charge.chargeAccountId)) {
        return 0
      }
    }
  }
  return 1
}

/**
 *  校验费用分公司是否为当前分公司或者当前分公司是否是费用分公司的上级公司
 * @param dataSource
 * @param isJob
 * @returns {Promise<boolean>}
 */
export async function checkChargeBranch(dataSource = [], isJob = false) {
  let charges = []
  if (isJob) {
    for (let i = 0; i < dataSource.length; i++) {
      const job = dataSource[i]
      const list = job['charges']
      if (list && list.length > 0) {
        charges = charges.concat(list)
      }
    }
  } else {
    charges = dataSource
  }
  if (charges && charges.length > 0) {
    let isSameBranchId = true
    // 1. 判断当前分公司是否与费用的branchID一致，
    console.log('')
    const currentOfficeId = $store.getters.currentOfficeId
    for (const charge of charges) {
      if (Number(charge.chargeBranchId) !== currentOfficeId) {
        isSameBranchId = false
        break
      }
    }
    // 2.若不一致，判断参数：可查看下级公司财务数据QueryChildernDataRole是否开启
    if (!isSameBranchId) {
      await cache.load(cacheName.CONFIG)
      const queryChildernDataRole = Number(cache.config.get('QueryChildernDataRole')) === 1
      // 3.是否可查看下级公司财务数据QueryChildernDataRole
      if (queryChildernDataRole) {
        let checkBranch = true
        for (const charge of charges) {
          if (Number(charge.chargeBranchId) !== currentOfficeId) {
            checkBranch = await SecurityUtil.checkChargeDetailBranch(charge.chargeBranchId)
            if (!checkBranch) {
              break
            }
          }
        }
        return checkBranch
      } else {
        return false
      }
    } else {
      return true
    }
  }
  return true
}

/**
 * 校验单条费用分公司是否可操作
 */
export async function isChargeRowBranchEditable(charge) {
  if (!charge) {
    return true
  }
  const currentOfficeId = $store.getters.currentOfficeId
  if (Number(charge.chargeBranchId) === currentOfficeId) {
    return true
  }
  await cache.load(cacheName.CONFIG)
  const queryChildernDataRole = Number(cache.config.get('QueryChildernDataRole')) === 1
  if (!queryChildernDataRole) {
    return false
  }
  return SecurityUtil.checkChargeDetailBranch(charge.chargeBranchId)
}
